import React from 'react';

// Grupos do menu (layout de outubro/2026). Só visual: quais módulos aparecem
// e em que ordem dentro do grupo continua vindo do navFiltrado (perfil de acesso).
export const GRUPOS_MENU = [
  { titulo: 'Dia a dia', ids: ['agenda', 'painel'] },
  { titulo: 'Clientes e vendas', ids: ['pessoas', 'prospeccao', 'licitacoes', 'marketing'] },
  { titulo: 'Gestão', ids: ['financeiro', 'relatorios', 'documentos'] },
  { titulo: 'Conhecimento', ids: ['ensino', 'diagnosticoNR1'] },
  { titulo: 'Sistema', ids: ['backup'] },
];

export function agruparMenu(itens) {
  const porId = Object.fromEntries(itens.map(i => [i.id, i]));
  const grupos = GRUPOS_MENU
    .map(g => ({ titulo: g.titulo, itens: g.ids.map(id => porId[id]).filter(Boolean) }))
    .filter(g => g.itens.length);
  const usados = new Set(grupos.flatMap(g => g.itens.map(i => i.id)));
  const soltos = itens.filter(i => !usados.has(i.id));
  if (soltos.length) grupos.push({ titulo: 'Outros', itens: soltos });
  return grupos;
}

export default function MenuLateral({ itens, atual, onSelect, badges = {} }) {
  return (
    <nav className="menu-lateral" aria-label="Módulos">
      {agruparMenu(itens).map(g => (
        <div key={g.titulo} className="menu-grupo">
          <h6>{g.titulo}</h6>
          {g.itens.map(item => {
            const n = badges[item.id];
            return (
              <button
                key={item.id}
                type="button"
                className={`menu-btn${atual === item.id ? ' ativo' : ''}`}
                aria-current={atual === item.id ? 'page' : undefined}
                onClick={() => onSelect(item.id)}
              >
                <span className="menu-emoji" aria-hidden="true">{item.emoji}</span>
                <span className="menu-rotulo">{item.label}</span>
                {n > 0 && <span className="menu-badge">{n > 99 ? '99+' : n}</span>}
              </button>
            );
          })}
        </div>
      ))}
    </nav>
  );
}
